import { Text } from "recharts";
import { PrimaryColor, QuaternaryColor, SecondaryColor } from "../../../common";
import { format } from "path";
import { ExchangeStateData } from "../../../store/state/Exchange/interface";
import { ReChartData } from "../../../models/chart_model";

export interface ExchngeItem {
  name: string | number;
  wt_mcp_rs_mwh: number | string | null;
  sell_bid_mw: number | string | null;
  purchase_bid_mw: number | string | null;
  mcv_mw: number | string | null;
  date: string | number;
}
// {
//   "buyer": "GEB Beneficiary W0RGU0",
//   "buyer_mwhr": "19508771.53",
//   "id": "22-10-2021",
//   "seller": "UPPCL N0RUP0",
//   "seller_mwhr": "15202311.95"

// },]

export interface BuyerSeller {
  buyer: string[];
  buyer_mwhr: number[];
  // date: string;
  seller: string[];
  seller_mwhr: number[];
}

export interface ExchangeData {
  dam: ExchngeItem[];
  gdam: ExchngeItem[];
  rtm: ExchngeItem[];
  hpdam: ExchngeItem[];
  [key: string]: ExchngeItem[]; // Add index signature
}

export interface ComparisonData {
  date: string;
  data: ExchangeStateData;
}

export function FormatExchangeData(data: any, isPxil = false): ExchangeData {
  let fomattedDataArray: ExchangeData = {
    dam: [],
    gdam: [],
    rtm: [],
    hpdam: [],
  };
  Object.keys(data).map((key, index) => {
    Object.keys(data[key].data).map((key2, index2) => {
      if (data[key].data[key2].length === 0) {
        const timeSlots = 96;
        for (let i = 0; i < timeSlots; i++) {
          fomattedDataArray[key2].push({
            name: i + 1,
            wt_mcp_rs_mwh: 0,
            sell_bid_mw: 0,
            purchase_bid_mw: 0,
            mcv_mw: 0,
            date: key,
          });
        }
      }
      data[key].data[key2].map((item: any, index: number) => {
        fomattedDataArray[key2].push({
          name: index + 1,
          wt_mcp_rs_mwh: item.wt_mcp_rs_mwh,
          sell_bid_mw: isPxil
            ? parseFloat(item.sell_bid_mw) * 4
            : parseFloat(item.sell_bid_mw),
          purchase_bid_mw: isPxil
            ? parseFloat(item.prchs_bid_mw) * 4
            : parseFloat(item.prchs_bid_mw),
          date: item.date,
          mcv_mw: parseFloat(item.mcv_mw),
        });
      });
    });
  });
  Object.keys(fomattedDataArray).map((key, index) => {
    fomattedDataArray[key] = fomattedDataArray[key].sort((a: any, b: any) => {
      const dateA = parseDate(a.date);
      const dateB = parseDate(b.date);

      return dateA.getTime() - dateB.getTime();
    });
  });

  return fomattedDataArray;
}

export const AxisLabel = ({
  axisType,
  x,
  y,
  width,
  height,
  stroke,
  children,
}: any) => {
  const isVert = axisType === "yAxis";
  const cx = isVert ? x : x + width / 2;
  const cy = isVert ? height / 2 + y : y + height + 10;
  const rot = isVert ? `270 ${cx} ${cy}` : 0;
  return (
    <Text
      x={cx}
      y={cy}
      transform={`rotate(${rot})`}
      textAnchor="middle"
      stroke={stroke}
    >
      {children}
    </Text>
  );
};

export const renderQuarterTick = (tickProps: any) => {
  const { x, y, payload } = tickProps;
  const { index, value, offset } = payload;
  const finalIndex = index + 1;
  if (finalIndex % 48 === 0 && finalIndex % 96 !== 0) {
    return (
      <text x={x} y={y - 4} textAnchor="middle">
        {value}
      </text>
    );
  }
};

export interface ExchangeChartData {
  title: string;
  timeBlocks: string[];
  date: string[];
  SellBids: number[];
  prchsBids: number[];
  mcv: number[];
  wtMcp: number[];
}

export interface RealTimeChartData {
  title: string;
  data: ReChartData[];
}
export interface RealTimeReChartData {}

export function FormatDataOfRealtime(data: any) {
  let formatedData: { name: number; price: number; date: string }[] = [];
  Object.keys(data).map((key, index) => {
    Object.keys(data[key]).map((key2, index2) => {
      Object.keys(data[key][key2]).map((key3, index3) => {
        formatedData.push({
          name: index3 + 1,
          price: parseFloat(data[key][key2][key3]),
          date: key,
        });
      });
    });
  });
  console.log(formatedData);
  return formatedData;
}

export interface BuyerSellerData {
  name: string;
  value: number;
}

export interface BuyerSellerItem {
  buyer: string;
  buyer_mwhr: number;
  seller: string;
  seller_mwhr: number;
}

const parseDate = (dateString: string): Date => {
  const [day, month, year] = dateString.split("-").map(Number);
  return new Date(year, month - 1, day); // Month is 0-indexed in JavaScript Dates
};

const BASE_EXCHANGE_COLORS: string[] = [
  PrimaryColor,
  SecondaryColor,
  "#118DFF",
  "#12239E",
  "#800080",
  "#FFA07A",
  "#006400",
  "#B76E79",
  "#B22222",
  "#2F4F4F",
  "#D2B48C",
  "#DC143C",
  "#000080",
  "#FF7F50",
  "#87CEEB",
  "#A52A2A",
  "#FF6347",
  "#8B0000",
  "#4B0082",
  "#C71585",
  "#2E8B57",
  "#C00000",
  "#A9A9A9",
  "#363636",
  "#696969",
  "#000000",
  "#6495ED",
  "#FF8C00",
  "#004347",
  "#9400D3",
  "#007F4E",
  "#FF0000",
  "#0018A8",
  "#4169E1",
  "#FFA500",
  "#FF4500",
];

const EXCHANGE_COLOR_TARGET_SIZE = 240;
const EXCHANGE_GOLDEN_ANGLE = 137.508;

const toHexColorChannel = (value: number): string =>
  Math.round(value).toString(16).padStart(2, "0");

const hslToHexColor = (h: number, s: number, l: number): string => {
  const hue = ((h % 360) + 360) % 360;
  const saturation = Math.max(0, Math.min(100, s)) / 100;
  const lightness = Math.max(0, Math.min(100, l)) / 100;

  const chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  const hueSection = hue / 60;
  const x = chroma * (1 - Math.abs((hueSection % 2) - 1));
  const match = lightness - chroma / 2;

  let red = 0;
  let green = 0;
  let blue = 0;

  if (hueSection >= 0 && hueSection < 1) {
    red = chroma;
    green = x;
  } else if (hueSection < 2) {
    red = x;
    green = chroma;
  } else if (hueSection < 3) {
    green = chroma;
    blue = x;
  } else if (hueSection < 4) {
    green = x;
    blue = chroma;
  } else if (hueSection < 5) {
    red = x;
    blue = chroma;
  } else {
    red = chroma;
    blue = x;
  }

  return `#${toHexColorChannel((red + match) * 255)}${toHexColorChannel(
    (green + match) * 255,
  )}${toHexColorChannel((blue + match) * 255)}`.toUpperCase();
};

const generateExchangeColor = (index: number): string => {
  const hue = (index * EXCHANGE_GOLDEN_ANGLE) % 360;
  const saturation = 64 + (index % 15); // 64-78
  const lightness = 42 + (index % 13); // 42-54
  return hslToHexColor(hue, saturation, lightness);
};

const exchangeColorSet = new Set(
  BASE_EXCHANGE_COLORS.map((color) => color.toUpperCase()),
);

for (
  let index = 0;
  exchangeColorSet.size < EXCHANGE_COLOR_TARGET_SIZE;
  index += 1
) {
  exchangeColorSet.add(generateExchangeColor(index));
}

export const ExchangeColors: string[] = Array.from(exchangeColorSet);

export interface ReformattedData {
  [key: string]: {
    [key: string]: {
      [key: string]: string | number | null;
    }[];
  };
}

export function reformatData(
  comparisonData: ComparisonData[],
): ReformattedData {
  const reformattedData: ReformattedData = {};

  comparisonData.forEach(({ date, data }) => {
    Object.keys(data).forEach((exchange) => {
      if (!reformattedData[exchange]) {
        reformattedData[exchange] = {};
      }
      Object.keys(data[exchange as keyof ExchangeStateData]).forEach(
        (dataType) => {
          if (!reformattedData[exchange][dataType]) {
            reformattedData[exchange][dataType] = [];
          }
          data[exchange as keyof ExchangeStateData][dataType].forEach(
            (item: any, index) => {
              // Add type annotation 'any' to 'item'
              if (!reformattedData[exchange][dataType][index]) {
                reformattedData[exchange][dataType][index] = {};
              }
              Object.keys(item).forEach((prop) => {
                const newKey = `${prop}_${date.replace(/-/g, "_")}`;
                reformattedData[exchange][dataType][index][newKey] = item[prop];
                reformattedData[exchange][dataType][index]["date"] =
                  item["date"];
                reformattedData[exchange][dataType][index]["time_slot"] =
                  item["time_slot"];
              });
            },
          );
        },
      );
    });
  });

  return reformattedData;
}

export function getDaysInMonthFromString(dateString: string): number {
  const [monthStr, yearStr] = dateString.split("-");
  const month = monthStr.substring(0, 3); // Extracting first three characters for month
  const year = parseInt(yearStr);

  const firstDayOfMonth = new Date(`${month} 1, ${year}`);
  const lastDayOfMonth = new Date(
    firstDayOfMonth.getFullYear(),
    firstDayOfMonth.getMonth() + 1,
    0,
  );

  return lastDayOfMonth.getDate();
}
